import { setDocChatStorageOwner } from 'features/knowledgeDocumentViewer/utils/docChatStorageOwner'
import { useGeckoPermissions } from 'features/permissions'

export const PENDING_DOC_CHAT_OWNER = 'pending-user'

/**
 * Claims DocChat browser storage for the signed-in user. Set during render so
 * the caller's state initializers never read another user's chats. Key the
 * stateful subtree by the returned value so it restores once the user loads.
 */
export function useDocChatStorageOwner(): string {
  const { user } = useGeckoPermissions()
  setDocChatStorageOwner(user?.id)
  return user?.id ?? PENDING_DOC_CHAT_OWNER
}
